/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { TypeActe } from '@/types';

/**
 * Valeur de `tableActe` (`ec_documents.dc_tableacte`) selon le type d'acte.
 *
 * ⚠️ Un document est rattaché à un acte par le COUPLE `identifiantActe` +
 * `tableActe` : deux actes de types différents peuvent porter le même
 * identifiant numérique.
 *
 * `EC_MMACT` n'y figure pas — ce sont les documents de mention, hors
 * numérisation.
 */
const TABLE_ACTE_BY_TYPE_ACTE: Partial<Record<TypeActe, string>> = {
  naissance: 'EC_ACTN',
  reconnaissance: 'EC_ACTR',
  deces: 'EC_ACTD',
  mariage: 'EC_ACTM',
};

export default TABLE_ACTE_BY_TYPE_ACTE;
